import Repository from "./Repository"
import axios from "axios"

export default {
  /**
   * Get about the circle
   */
  getAboutCircle(circle_id, user_id) {
    const uid = user_id ? "&user_id=" + user_id : ""
    return Repository.get(`/circleinfo/?id=${circle_id}${uid}`)
  },
  /**
   * Get doveMed stats
   */
  getDoveMedStats() {
    return axios({
      method: "get",
      url: `${process.env.SSO_BASE_URL}/api/v2/utils/dovemed-stats/`,
    })
  },
  /**
   * Get a comment details
   */
  getCommentDetails(id) {
    return Repository.get(`/comments/?id=${id}`
    );
  },
  /**
   * Get replies list
   */
  getCommentReplies(id, type = 'commentsonpostcomment', page = 1, item = 1) {
    return Repository.get(`/${type}/?page_num=${page}&items=${item}&comment_id=${id}`
    );
  },
  /**
   * Get circle images
   */
  getMedia(id, page = 1, items = 10) {
    return Repository.get(`/images/?page_num=${page}&items=${items}&circle_id=${id}`)
  },
  /**
   * Get reports
   */
  getReports(id, page = 1, items = 10, sort = "") {
    const s =
      sort !== "" ? (sort === "post" ? "&post=true" : "&comment=true") : "";
    return Repository.get(
      `/moderatorreactions/?circle_id=${id}&page_num=${page}&items=${items}` + s
    );
  },
  /**
   * Keep reported post
   */
  keepReportedPost(circle_id, reacted_on_id, reacted_on_type) {
    return Repository.get(`/moderatorreactions/?circle_id=${circle_id}&keep=true&reacted_on_id=${reacted_on_id}&reacted_on_type=${reacted_on_type}`)
  },
  /**
   * Remove reported post
   */
  removeReportedPost(circle_id, reacted_on_id, reacted_on_type) {
    return Repository.get(`/moderatorreactions/?circle_id=${circle_id}&remove=true&reacted_on_id=${reacted_on_id}&reacted_on_type=${reacted_on_type}`)
  },
}



// WEBPACK FOOTER //
// ./src/repositories/aboutCircleRepository.js